import moment from 'moment';

export default class ChildStatusTransition {
    static fromData(data) {
        if (!data) {
            return;
        }

        let statusTransition = new ChildStatusTransition();
        statusTransition.id = data.id;
        statusTransition.name = data.name;
        statusTransition.date = moment(data.date);
        statusTransition.targetStatus = data.target_status;

        Object.seal(statusTransition);
        return statusTransition;
    }

    isInFuture() {
        return this.date > new Date();
    }
}
